<template>
  <b-modal
    :active="true"
    has-modal-card
    trap-focus
    :destroy-on-hide="true"
    aria-role="dialog"
    aria-modal
    custom-class="documents-add-url-modal"
  >
    <form class="documents-add-url-form" @submit.prevent="onAddUrl">
      <div class="modal-card documents-add-url-modal-card">
        <header class="modal-card-head documents-add-url-modal-head">
          <p class="modal-card-title documents-add-url-modal-title">
            Add external URL
          </p>
        </header>

        <section class="modal-card-body documents-add-url-modal-body">
          <b-field class="documents-add-url-field" label="Title">
            <b-input
              v-model="externalURLTitle"
              placeholder="Enter title"
              required
            />
          </b-field>

          <b-field class="documents-add-url-field" label="URL">
            <b-input
              v-model="externalURL"
              type="text"
              placeholder="Enter URL"
              required
            />
          </b-field>
        </section>

        <footer class="modal-card-foot documents-add-url-modal-foot">
          <b-button
            class="documents-add-url-close-btn"
            label="Close"
            @click="close"
          />
          <b-button
            class="documents-add-url-submit-btn"
            native-type="submit"
            label="Add"
            type="is-primary"
          />
        </footer>
      </div>
    </form>
  </b-modal>
</template>
<script>
export default {
  name: 'ExternalUrlModal',

  data() {
    return {
      externalURLTitle: '',
      externalURL: '',
    };
  },

  methods: {
    onAddUrl() {
      const { externalURLTitle, externalURL } = this;
      this.$emit('onAddUrl', { externalURLTitle, externalURL });
      this.close();
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}

.documents-add-url-modal .animation-content,
.documents-add-url-modal .modal-content {
  width: 560px !important;
}

.documents-add-url-modal .modal-card,
.documents-add-url-modal-card {
  width: 560px !important;
  max-width: 560px !important;
  margin: 0 auto !important;
  overflow: hidden !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18) !important;
  text-align: left !important;
}

.documents-add-url-modal-head {
  padding: 16px 20px !important;
  border-bottom: 1px solid #e5e7eb !important;
  background: #fff !important;
}

.documents-add-url-modal-title {
  font-size: 18px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
  color: #1f2937 !important;
  margin: 0 !important;
}

.documents-add-url-modal-body {
  padding: 20px !important;
  background: #fff !important;
}

.documents-add-url-field {
  margin-bottom: 16px !important;
}

.documents-add-url-field:last-child {
  margin-bottom: 0 !important;
}

.documents-add-url-modal .field label.label,
.documents-add-url-modal .documents-add-url-field label.label {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #374151 !important;
  margin-bottom: 6px !important;
}

.documents-add-url-modal .input,
.documents-add-url-modal .textarea {
  min-height: 40px !important;
  border-radius: 8px !important;
  border: 1px solid #d1d5db !important;
  box-shadow: none !important;
}

.documents-add-url-modal .input:focus,
.documents-add-url-modal .textarea:focus {
  border-color: #3273dc !important;
  box-shadow: 0 0 0 1px #3273dc !important;
}

.documents-add-url-close-btn,
.documents-add-url-submit-btn {
  min-width: 110px !important;
}

.documents-add-url-modal .modal-background {
  background: rgba(10, 10, 10, 0.5) !important;
}
</style>
